// src/components/Loader.js
import React from "react";
import {
  CircularProgress,
  Backdrop,
  Box,
  Button,
} from "@mui/material";

const Loader = ({
  type = "component",
  loading = false,
  height = 250,
  children,
  buttonProps = {},
}) => {
  // ===== Full Screen Loader =====
  if (type === "full" && loading) {
    return (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 100,
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          bgcolor: "transparent", // no background overlay
        }}
      >
        <CircularProgress
          size={50}
          thickness={5}
          sx={{ color: '#548ce8' }}
        />
      </Box>
    );
  }

  // ===== Table Loader (MUI / AntD) =====
  if (type === "table" && loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height,
        }}
      >
        <CircularProgress size={40} />
      </Box>
    );
  }

  // ===== Button Loader =====
  if (type === "button") {
    return (
      <Button
        {...buttonProps}
        disabled={loading || buttonProps.disabled}
        startIcon={
          loading ? <CircularProgress size={18} color="inherit" /> : null
        }
      >
        {loading ? "Please wait..." : children}
      </Button>
    );
  }

  // ===== Modal Loader =====
  if (type === "modal" && loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: 3,
        }}
      >
        <CircularProgress size={28} />
      </Box>
    );
  }

  // ===== Component / Inline Loader =====
  if (type === "component" && loading) {
    return (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          minHeight: "100px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // ===== Default: Return children when not loading =====
  return children || null;
};

export default Loader;
